import React from 'react';
import cls from 'clsx';
import styles from './images.module.css';

interface ImagePlaceholderProps {
  className?: string;
  style?: React.CSSProperties;
}

const ImagePlaceholder: React.FC<ImagePlaceholderProps> = ({
  className,
  style
}) => {
  return (
    <div className={cls(styles.imagePlaceholder, className)} style={style} />
  );
};

export default ImagePlaceholder;
